import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canViewAdminDashboard, isAdmin, isSuperAdmin } from '../permissions';

export const useAdminPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canViewAdminDashboard: bindViewer(canViewAdminDashboard),
      isAdmin: bindViewer(isAdmin),
      isSuperAdmin: bindViewer(isSuperAdmin),
    }),
    [bindViewer],
  );
};
